const childWindows = [];

export const openChildWindow = (url) => {
    let target = '_blank';

    if (url.includes('logout')) {
        target = '';
    }

    const win = window.open(url, target);
    if (win) {
        childWindows.push(win);
    }
    return win;
};

export const sendToAllChildWindows = (message, origin) => {
    childWindows.forEach(win => {
        try {
            if (!win.closed) {
                win.postMessage(message, origin);
            }
        } catch (error) {
            console.error('Error sending to child window:', error);
        }
    });
};

export const closeAllChildWindows = () => {
    childWindows.forEach(win => !win.closed && win.close());
    childWindows.length = 0;  // Clear the array
};

export const trackChildWindow = (win) => {
    childWindows.push(win);
};